import type {UserType} from '../../core/usecases/auth/AuthContext';

/**
 * Get current year and month information
 */
export const getCurrentDateInfo = () => {
  const currentDate = new Date();
  return {
    currentYear: currentDate.getFullYear(),
    currentMonth: currentDate.getMonth() + 1,
  };
};

type GraduationYearOptions = {
  user?: UserType;
  // バックエンドから取得したメイン卒年（API経由で渡された場合はこの値を使用）
  apiMainGraduationYear?: number;
};

/**
 * Calculate graduation year information based on current date and user data
 * @param options.user - ログインユーザー情報
 * @param options.apiMainGraduationYear - バックエンドから取得したメイン卒年（推奨）
 */
export const getGraduationYearInfo = (
  options?: GraduationYearOptions | UserType,
) => {
  // 後方互換性: UserTypeが直接渡された場合の処理
  const isUserType = options && 'id' in options;
  const user = isUserType ? options : options?.user;
  const apiMainGraduationYear = isUserType
    ? undefined
    : options?.apiMainGraduationYear;

  const {currentYear, currentMonth} = getCurrentDateInfo();

  // メイン卒年: APIから取得した値を優先、なければローカル計算（フォールバック）
  const calculatedMainGraduationYear =
    currentMonth < 4 ? currentYear + 1 : currentYear + 2;
  const mainGraduationYear =
    apiMainGraduationYear ?? calculatedMainGraduationYear;
  const userGraduationYear = user?.graduationYear || mainGraduationYear;
  const previousGraduationYear = userGraduationYear - 1;

  return {
    mainGraduationYear,
    userGraduationYear,
    previousGraduationYear,
    previousGraduationYearShort: previousGraduationYear % 100,
  };
};

/**
 * Format graduation year to short format (last 2 digits)
 */
export const formatGraduationYearShort = (year: number): number => {
  return year % 100;
};
